export type IssuingTransaction = {
  id: number;
  createdAt: string;
  updatedAt: string;
  bookingId: number;
  status: IssuingTransactionStatus;
  type: IssuingTransactionType;
  amount: number;
  authorizationId?: string;
  authorizedAt?: string;
  transactionId?: string;
  chargedAt?: string;
};

export enum IssuingTransactionStatus {
  PENDING = 'PENDING',
  VALIDATED = 'VALIDATED',
  REVERSED = 'REVERSED',
}

export enum IssuingTransactionType {
  CAPTURE = 'CAPTURE',
  REFUND = 'REFUND',
}
